import { client } from '@/api/common';
import {
  API,
  BASE,
  V1,
  URL_ADVISOR,
  URL_ADVISOR_STATUS,
  URL_ADVISOR_PROFILE,
  URL_ADVISOR_CLIENTS,
  URL_ADVISOR_OPEN,
} from '@/lib/constants/urls';
import type { ListResponse } from '@repo/api';
import type {
  AdvisorStatus,
  AdvisorProfile,
  AdvisorProfilePayload,
  AdvisorClient,
} from './models';
import { normalizeAdvisorClient } from './normalize-advisor-client';

const ADVISOR_BASE = `${BASE}${API}${V1}${URL_ADVISOR}`;

export const fetchAdvisorStatus = async (): Promise<AdvisorStatus> => {
  const response = await client<AdvisorStatus>({
    url: `${ADVISOR_BASE}${URL_ADVISOR_STATUS}`,
    method: 'GET',
  });
  return response.data;
};

export const fetchAdvisorProfile = async (): Promise<AdvisorProfile | null> => {
  const response = await client<AdvisorProfile | null>({
    url: `${ADVISOR_BASE}${URL_ADVISOR_PROFILE}`,
    method: 'GET',
  });
  return response.data;
};

export const updateAdvisorProfile = async (
  payload: AdvisorProfilePayload
): Promise<AdvisorProfile> => {
  const response = await client<AdvisorProfile>({
    url: `${ADVISOR_BASE}${URL_ADVISOR_PROFILE}`,
    method: 'PATCH',
    data: payload,
  });
  return response.data;
};

export const fetchAdvisorClients = async (): Promise<
  ListResponse<AdvisorClient>
> => {
  const response = await client<ListResponse<AdvisorClient>>({
    url: `${ADVISOR_BASE}${URL_ADVISOR_CLIENTS}`,
    method: 'GET',
  });
  return {
    ...response.data,
    data: response.data.data.map(normalizeAdvisorClient),
  };
};

export const openAdvisorClient = async (
  tenantId: string
): Promise<{ success: true }> => {
  const response = await client<{ success: true }>({
    url: `${ADVISOR_BASE}${URL_ADVISOR_CLIENTS}/${tenantId}${URL_ADVISOR_OPEN}`,
    method: 'POST',
  });
  return response.data;
};
